export default __webpack_public_path__ + "static/media/CERTIFICADO_HALU_V@_0000s_0003_assinatura-halu.4bd1de2f.png";